var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-warning"},[_vm._v("\n    Veuillez renseigner au moins un représentant légal pour compléter l'étape\n")])}
var staticRenderFns = []

export { render, staticRenderFns }